export default "__VITE_ASSET__NPwIcA8w__"